import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const external_link: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...rest}>
      <path
        fill="none"
        stroke={iconColor}
        d="M19.5,4.4992 L15,8.9992 M16,4.4992 L19.5,4.4992
      L19.5,7.9992 M13,7.5002 L4.5,7.5002 L4.5,19.5002 L16.5,19.5002 L16.5,11.0002"
      />
    </svg>
  );
};
